// Step3.js - Ticketing Issues (Updated seat validation to allow more symbols) + Photo Upload

import ModernDataTable from '../ui/ModernDataTable';

const Step3 = ({
      ticketingItems,
      setTicketingItems,
      defaultDateTime,
      enablePhotoUpload,
      referenceNo,
      sectionName,
      dataTableRef
}) => {
      const ticketingFields = [
            {
                  name: 'timeRaised',
                  type: 'datetime',
                  label: 'Time Raised',
                  header: 'Time raised',
                  required: true,
                  maxDate: new Date().toISOString(),
                  validationMessage: 'Please enter when the ticketing issue was raised (cannot be in the future)',
                  hint: 'Record the exact time when the ticketing issue was first reported or discovered. This helps track response times and patterns.'
            },
            {
                  name: 'description',
                  type: 'textarea',
                  label: 'Describe the issue',
                  header: 'Description',
                  placeholder: 'Provide details about what happened with the ticketing...',
                  required: true,
                  validationMessage: 'Please describe the ticketing issue in detail',
                  hint: (
                        <div>
                              <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Describe the ticketing issue including:</p>
                              <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                                    <li>What went wrong with the tickets</li>
                                    <li>How many patrons were affected</li>
                                    <li>The nature of the problem (duplicate seats, invalid tickets, system issues, etc.)</li>
                                    <li>Any immediate impact on patrons or event operations</li>
                              </ul>
                        </div>
                  )
            },
            {
                  name: 'patronRelocated',
                  type: 'checkbox',
                  label: 'Was the patron relocated to a new seat?',
                  header: 'Relocated?',
                  hint: 'Check this box if any patrons had to be moved to different seats as part of resolving this ticketing issue.'
            },
            {
                  name: 'seatFields',
                  type: 'grid',
                  gridColumns: '1fr 1fr',
                  condition: (data) => data.patronRelocated,
                  fields: [
                        {
                              name: 'originalSeat',
                              type: 'text',
                              label: 'Original Seat Number',
                              header: 'Original seat',
                              placeholder: 'e.g. A12, Section 3 Row 5 Seat 10, Box #15',
                              pattern: '^[A-Za-z0-9\\s\\-\\/\\#\\.\\_\\,\\(\\)\\+\\&]+$',
                              patternMessage: 'Seat number contains invalid characters. Most letters, numbers, and common symbols are allowed.',
                              conditionalRequired: {
                                    condition: { field: 'patronRelocated', value: true },
                                    message: 'Please enter the original seat number that had the issue'
                              },
                              hint: 'Enter the seat number exactly as it appears on the ticket or venue seating chart.'
                        },
                        {
                              name: 'newSeat',
                              type: 'text',
                              label: 'New Seat Number',
                              header: 'New seat',
                              placeholder: 'e.g. B15, Section 2 Row 3 Seat 8, Box #20',
                              pattern: '^[A-Za-z0-9\\s\\-\\/\\#\\.\\_\\,\\(\\)\\+\\&]+$',
                              patternMessage: 'Seat number contains invalid characters. Most letters, numbers, and common symbols are allowed.',
                              hideInTable: false,
                              conditionalRequired: {
                                    condition: { field: 'patronRelocated', value: true },
                                    message: 'Please enter the new seat number where the patron was relocated'
                              },
                              hint: 'Enter the replacement seat number where the patron was moved to resolve the issue.'
                        }
                  ]
            },
            {
                  name: 'actionsToResolve',
                  type: 'textarea',
                  label: 'Any other actions taken to resolve',
                  header: 'Actions',
                  placeholder: 'Describe any additional actions taken to resolve the issue...',
                  hint: (
                        <div>
                              <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Document any additional resolution actions such as:</p>
                              <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                                    <li>Refunds or compensation provided</li>
                                    <li>Upgrades offered to patrons</li>
                                    <li>Staff notifications or escalations</li>
                                    <li>System corrections or fixes applied</li>
                                    <li>Follow-up actions required</li>
                              </ul>
                        </div>
                  )
            }
      ];

      return (
            <ModernDataTable
                  suppressTitle={true}
                  data={ticketingItems}
                  setData={setTicketingItems}
                  fields={ticketingFields}
                  addButtonText="Add Ticketing Issue"
                  emptyMessage="No ticketing issues added yet."
                  truncateLines={2}
                  defaultDateTime={defaultDateTime}
                                          enablePhotoUpload={enablePhotoUpload}
                                          referenceNo={referenceNo}
                                          sectionName={sectionName}
                                          ref={dataTableRef}
            />
      );
};

export default Step3;